import { Component, ViewEncapsulation, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SpinnerOverlayService } from 'src/app/services/spinnerOverlay.service';
import { lastValueFrom } from 'rxjs';
import SimpleSubscriber from 'src/app/models/simpleSubscriber';
import { MemberService } from 'src/app/services/member.service';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'deactivate-dialog',
  templateUrl: 'deactivateDialog.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None,
})
export class DeactivateDialogComponent {

    @Input() selectedSubscriber : SimpleSubscriber;
    dialogOpened : boolean = false;
    @ViewChild('deactivateButton') btnRef;
    @Output() memberDeactivationChanged = new EventEmitter();
    
    constructor(
        private memberService : MemberService, 
        private coreService : CoreService) {

    }

    openDeactivateDialog() {
        this.dialogOpened = true;
    }

    closeDeactivateDialog(toggleDeactivatedInd: boolean) {
        if (toggleDeactivatedInd) {
            this.toggleDeactivatedInd();
        }
        this.dialogOpened = false;
    }

    async toggleDeactivatedInd(): Promise<void> {
        try {
            await lastValueFrom(this.memberService.setMemberDeactivatedInd(this.selectedSubscriber?.memberId, !this.selectedSubscriber?.deactivatedInd));
            this.memberDeactivationChanged.emit();
        } catch (error) {
            this.coreService.popMessage('There was an error updating the member.', 'error', 2000);
        }
    }
}